//@ts-nocheck
export const fillTemplate = (templateString: any, templateVariables: any) => templateString.replace(/\${(.*?)}/g, (_, g) => templateVariables[g]);